export default {

    actionBox: {
        background: "#E5EEFA",
        marginTop: "40px",
        borderRadius: "3px",
        boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
        padding: "30px 40px"
    },

    count: {
        fontSize: "20px",
        margin: "5px 0 0 0",
    },

    infoText: {
        fontSize: "14px",
        color: "#676767",
        fontWeight: "400"
    },

    actionDropdown: {
        background: "#F8FAFB",
        border: "1px solid #215DAA",
        borderRadius: "80px",
        padding: "6px 22px",
    },

    actionDropdownLabel: {
        marginRight: "15px",
        color: "#215DAA"
    },

    actionDropdownMenu: {
        width: "max-content",
        minWidth: "auto",
        left: "-70px",
        top: "29px",
    },

    buttonContainer: {
        marginTop: "30px",
        display: "flex",
        columnGap: "15px"
    },

    informationBox: {
        margin: "30px 0 20px 0",
    },

    payerInfo: {
        display: "flex",
        columnGap: "15px"
    },

    information: {
        display: "flex",
        columnGap: "50px",
        marginTop: "20px",
        paddingBottom: "20px",
        borderBottom: "1px solid #BEBEBE"
    },

    info: {
        display: 'flex',
        flexDirection: "column"
    },

    flexboxContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        rowGap: "20px",
        marginTop: "10px"
    },

    box: {
        flex: '1 1 calc(50% - 10px)',
        margin: '5px',
    },

    horizontalLine: {
        margin: "20px 0",
    },

    alert: {
        display: "flex",
        columnGap: "5px",
        marginBottom: "10px"
    }
}